// extracted by mini-css-extract-plugin
export default {"caption":"style_caption__2t35F","toCapitalize":"style_toCapitalize__x1FhO","attachmentName":"style_attachmentName__LkOqP","label":"style_label__c4jVz"};